export const showEmailConfirmation = () => {
	const emailConfirmationEl = document.getElementById('email-confirmation');
	if (!emailConfirmationEl) return;

	emailConfirmationEl.classList.remove('hidden');
}
